<!--NAVEGACAO DA DASHBOARD-->
<template>
  <div id="all">
    <!--CODIGO DA SIDEBAR-->
    <div v-if="RetornaTam()">
      <!--HEADER-->

      <div class="s-header">
        <transition name="slide">
          <div v-if="show" id="logo-slide" class="logo-open row">
            <img src="../assets/dashboard/sidebar/logo.png" alt />
            <div class="logo-text">CompJr Admin</div>
          </div>
          <!---->
          <div v-else id="logo-slide" class="logo-closed row">
            <img src="../assets/dashboard/sidebar/logo.png" alt />
            <div class="logo-text">CompJr Admin</div>
          </div>
        </transition>
        <!--<botao
          class="logout"
          :Load="loading"
          @click="handleSignOutEvent"
          Variante="compbranco"
          _Tamanho="sm"
          TextoBotao="Logout"
        />-->
        <button class="logout" @click="handleSignOutEvent">Logout</button>
      </div>

      <div class="closed"></div>
      <!--ICONS-->
      <div v-if="show">
        <div @click="TrocaShow" class="menu-icon">
          <a v-show="show" href="#">
            <img src="../assets/dashboard/sidebar/hamburger.png" alt />
          </a>
          <img v-show="!show" src="../assets/dashboard/sidebar/hamburger.png" alt />
        </div>
        <div v-if="select == 1" class="icon i1" @click="Just1()">
          <router-link to="/dashboard" href="#">
            <img src="../assets/dashboard/sidebar/icon1a.png" alt />
          </router-link>
        </div>
        <div v-else class="icon i1" @click="Just1()">
          <router-link to="/dashboard">
            <img src="../assets/dashboard/sidebar/icon1.png" alt />
          </router-link>
        </div>
        <!---->
        <div v-if="select == 2" class="icon i2" @click="Just2()">
          <router-link to="/dashboard/cases">
            <img src="../assets/dashboard/sidebar/icon2a.png" alt />
          </router-link>
        </div>
        <div v-else class="icon i2" @click="Just2()">
          <router-link to="/dashboard/cases">
            <img src="../assets/dashboard/sidebar/icon2.png" alt />
          </router-link>
        </div>
        <!---->
        <div v-if="select == 3" class="icon i3" @click="Just3()">
          <router-link to="/dashboard/contato">
            <img src="../assets/dashboard/sidebar/icon3a.png" alt />
          </router-link>
        </div>
        <div v-else class="icon i3" @click="Just3()">
          <router-link to="/dashboard/contato">
            <img src="../assets/dashboard/sidebar/icon3.png" alt />
          </router-link>
        </div>
        <!---->
        <div v-if="select == 4" class="icon i4" @click="Just4()">
          <router-link to="/dashboard/orcamento">
            <img src="@/assets/dashboard/sidebar/icon4a.png" alt />
          </router-link>
        </div>
        <div v-else class="icon i4" @click="Just4()">
          <router-link to="/dashboard/orcamento">
            <img src="@/assets/dashboard/sidebar/icon4.png" alt />
          </router-link>
        </div>
      </div>

      <div v-else>
        <div @click="TrocaShow" class="menu-icon">
          <a href="#">
            <img src="../assets/dashboard/sidebar/hamburger.png" alt />
          </a>
        </div>
        <div v-if="select == 1" class="icon i1">
          <img src="../assets/dashboard/sidebar/icon1a.png" alt />
        </div>
        <div v-else class="icon i1">
          <img src="../assets/dashboard/sidebar/icon1.png" alt />
        </div>
        <!---->
        <div v-if="select == 2" class="icon i2">
          <img src="../assets/dashboard/sidebar/icon2a.png" alt />
        </div>
        <div v-else class="icon i2">
          <img src="../assets/dashboard/sidebar/icon2.png" alt />
        </div>
        <!---->
        <div v-if="select == 3" class="icon i3">
          <img src="../assets/dashboard/sidebar/icon3a.png" alt />
        </div>
        <div v-else class="icon i3">
          <img src="../assets/dashboard/sidebar/icon3.png" alt />
        </div>
        <!---->
        <div v-if="select == 4" class="icon i4">
          <img src="../assets/dashboard/sidebar/icon4a.png" alt />
        </div>
        <div v-else class="icon i4">
          <img src="../assets/dashboard/sidebar/icon4.png" alt />
        </div>
      </div>

      <!--TOPICS-->

      <transition name="show">
        <div v-if="show" class="open">
          <a href="#">
            <p class="topics t0">Menu</p>
          </a>
          <a v-if="select == 1" href="#">
            <p class="topics t1a">Dashboard</p>
          </a>
          <a v-else href="#">
            <p class="topics t1">Dashboard</p>
          </a>
          <a v-if="select == 2" href="#">
            <p class="topics t2a">Cases</p>
          </a>
          <a v-else href="#">
            <p class="topics t2">Cases</p>
          </a>
          <a v-if="select == 3" href="#">
            <p class="topics t3a">Contato</p>
          </a>
          <a v-else href="#">
            <p class="topics t3">Contato</p>
          </a>
          <a v-if="select == 4" href="#">
            <p class="topics t4a">Orçamento</p>
          </a>
          <a v-else href="#">
            <p class="topics t4">Orçamento</p>
          </a>
        </div>
      </transition>
    </div>
    <!--CODIGO DA NAVBAR PARA MOBILE-->
    <div v-else>
      <div>
        <b-navbar id="nav" type="dark" toggleable="lg">
          <b-navbar-brand>
            <b-row id="logo">
              <img src="../assets/dashboard/sidebar/logo.png" alt />
              <div>CompJr Admin</div>
            </b-row>
          </b-navbar-brand>

          <b-navbar-toggle target="nav-collapse">
            <img id="toggle" src="../assets/dashboard/sidebar/hamburger.png" alt />
          </b-navbar-toggle>

          <b-collapse id="nav-collapse" is-nav>
            <b-navbar-nav id="drop">
              <b-nav-item>
                <router-link href="#" to="/dashboard">
                  <div id="item">Dashboard</div>
                </router-link>
              </b-nav-item>
              <b-nav-item>
                <router-link href="#" to="/dashboard/cases">
                  <div id="item">Cases</div>
                </router-link>
              </b-nav-item>
              <b-nav-item>
                <router-link href="#" to="/dashboard/contato">
                  <div id="item">Contato</div>
                </router-link>
              </b-nav-item>
              <b-nav-item>
                <router-link href="#" to="/dashboard/orcamento">
                  <div id="item">Orçamento</div>
                </router-link>
              </b-nav-item>
              <b-nav-item>
                <router-link href="#" to="#">
                  <div @click="handleSignOutEvent" id="item">Logout</div>
                </router-link>
              </b-nav-item>
            </b-navbar-nav>
          </b-collapse>
        </b-navbar>
      </div>
    </div>
  </div>
</template>

<script>
//import Botao from "./Botao.vue";
import { RemoveCookie } from "@/utils/CookieUtil";

export default {
  data() {
    return {
      show: false,
      select: 1,
      loading: false
    };
  },
  components: {
    //botao: Botao
  },
  methods: {
    TrocaShow() {
      this.show = !this.show;
      this.$emit("testeshow");
    },
    RetornaTam() {
      if (window.innerWidth > 480) {
        return true;
      } else {
        return false;
      }
    },
    Just1() {
      //DASHBOARD
      this.select = 1;
      this.show = false;
      this.$emit("testeshow");
    },
    Just2() {
      //CASES
      this.select = 2;
      this.show = false;
      this.$emit("testeshow");
    },
    Just3() {
      //CONTATO
      this.select = 3;
      this.show = false;
      this.$emit("testeshow");
    },
    Just4() {
      //ORCAMENTO
      this.select = 4;
      this.show = false;
      this.$emit("testeshow");
    },
    async handleSignOutEvent() {
      if (!this.loading) {
        this.loading = true;
        await RemoveCookie("token");
        this.$router.push({ name: "Admin" });
      }
      this.loading = false;
    }
  },
  mounted: function() {
    this.$root.$on("atualizarSideBar", index => {
      this.select = index;
    });
  }
};
</script>

<style scoped>
@font-face {
  font-family: "Montserrat";
  src: url("../assets/fonts/Montserrat-Medium.ttf") format("truetype");
}

#all {
  font-family: "Montserrat";
}

.s-header {
  position: fixed;
  height: 73px;
  top: 0;
  width: 100%;
  background-color: #1793a6;
  z-index: 5;
}

.logo-open {
  width: 250px;
  height: 33.95px;
  margin-left: 271px;
  margin-top: 19px;
  font-weight: 24px;
  line-height: 24px;
  letter-spacing: -0.045em;
  transition: 0.6s;
}

.logo-closed {
  width: 250px;
  height: 33.95px;
  margin-left: 110px;
  margin-top: 19px;
  font-weight: 24px;
  line-height: 24px;
  letter-spacing: -0.045em;
  transition: 0.6s;
}

.logo-text {
  /*background-color: crimson;*/
  margin-left: 30px;
  margin-top: 5px;
  font-weight: 500;
  font-size: 20px;
  line-height: 24px;
  letter-spacing: -0.045em;
  color: #ffffff;
}

.logout {
  border: none;
  color: #1793a6;
  position: relative;
  margin-top: -36px;
  float: right;
  margin-right: 39px;
  z-index: 10;
  width: 100px;
  height: 40px;
  background: #ffffff;
  border-radius: 5px;
  font-weight: 300;
  font-size: 16px;
  line-height: 20px;
}
.logout:hover {
  color: #ffffff;
  background: transparent;
  border: 2px solid #ffffff;
}

.open {
  position: fixed;
  width: 241px;
  height: 100%;
  left: 0;
  top: 0;
  background-color: #104249;
  z-index: 5;
}

.closed {
  position: fixed;
  width: 80px; /*80*/
  height: 100%;
  left: 0;
  top: 0;
  background-color: #104249;
  z-index: 6;
}

.menu-icon {
  position: fixed;
  width: 21.65px;
  height: 27.08px;
  margin-left: 29.175px;
  top: 25px;
  z-index: 6;
}

.icon {
  position: fixed;
  width: 29px;
  height: 29px;
  z-index: 6;
}

.i1 {
  left: 25.5px;
  top: 86px;
}
.i2 {
  left: 25.5px;
  top: 141px;
}
.i3 {
  left: 25.5px;
  top: 196px;
}
.i4 {
  left: 25.5px;
  top: 250px;
}

.icon a {
  position: absolute;
  width: 200px;
  height: 40px;
  z-index: 70;
}

.topics {
  position: fixed;
  font-style: normal;
  font-weight: 500;
  font-size: 16px; /*16px*/
  line-height: 20px;
  letter-spacing: -0.035em;
  z-index: 1;
  color: #a7a7a7;
}

.topics:hover {
  color: #ffffff;
}

.t0 {
  top: 28px;
  left: 85px;
  color: #ffffff;
}

.t1 {
  left: 90.71px;
  top: 90px;
}
.t2 {
  left: 90.71px;
  top: 141px;
}
.t3 {
  left: 90.71px;
  top: 200px;
}
.t4 {
  left: 90.71px;
  top: 254px;
}

.t1a {
  left: 90.71px;
  top: 90px;
  color: #ffffff;
}
.t2a {
  left: 90.71px;
  top: 141px;
  color: #ffffff;
}
.t3a {
  left: 90.71px;
  top: 200px;
  color: #ffffff;
}
.t4a {
  left: 90.71px;
  top: 254px;
  color: #ffffff;
}

.slide-enter-active,
.slide-leave-active {
  transition: 0.6s;
}
.slide-enter,
.show-leave-to {
  transform: translateX(-241);
}

.show-enter-active {
  transition: 0.5s;
}
.show-leave-active {
  transition: 0.4s;
}
.show-enter, .show-leave-to /* .show-leave-active em versões anteriores a 2.1.8 */ {
  transform: translateX(-241px);
}

#logo {
  margin-left: 10px;
}

#logo div {
  margin-top: 5px;
  margin-left: 15px;
  font-size: 80%;
}

#nav {
  background-color: #1793a6;
}

#drop {
  margin-top: 10px;
  margin-left: 10px;
}

#item {
  color: #e8e8e8;
  text-decoration: none;
}

#item:hover {
  color: white;
  text-decoration: none;
}

#toggle {
  transform: scaleX(-1);
}

@media only screen and (max-width: 650px) {
  .logo-open div {
    margin-left: 30px;
    margin-top: 5px;
    color: #1793a6;
    z-index: -1;
  }
  .logo-closed div {
    margin-left: 30px;
    margin-top: 5px;
    color: #1793a6;
    z-index: -1;
  }
}
</style>
